/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute path='/invite/courier/:courierId'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import RegisterPage from '@routes/RegisterPage';

export const Route = createFileRoute('/invite/courier/$courierId')({
  component: () => (
    <CacheDataRoute
      component={RegisterPage}
      path='/invite/courier/:courierId'
    />
  )
});
